import { render, staticRenderFns } from "./classes-color-picker.vue?vue&type=template&id=1b459b37&"
import script from "./classes-color-picker.vue?vue&type=script&lang=js&"
export * from "./classes-color-picker.vue?vue&type=script&lang=js&"
import style0 from "./classes-color-picker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports